/* eslint-disable no-undef */
import getCardFlag from '../utils/getCardFlag';

export default {
  getIssuer(ccNumber) {
    return new Promise((resolve, reject) => {
      const firstTwoNumbers = ccNumber.replace(/[ .-]/g, '').slice(0, 2);

      const getFlagByNumber = getCardFlag(firstTwoNumbers);

      const binNumber = ccNumber.replace(/[ .-]/g, '').slice(0, 6);

      Mercadopago.getPaymentMethod({ bin: binNumber }, (status, res) => {
        if (status === 200) {
          if (res.length > 1) {
            const hasMasterAndEloInResults = res.every(
              method => method.id === 'master' || method.id === 'elo'
            );

            if (hasMasterAndEloInResults && getFlagByNumber) {
              resolve(getFlagByNumber);
            }
          }
          const issuer = res[0].id;
          gon.cardIssuer = issuer;
          resolve(issuer);
        } else {
          reject(res.message);
        }
      });
    });
  },

  getInstallments(number, amount) {
    return new Promise((resolve, reject) => {
      const bin = number.replace(/[ .-]/g, '').slice(0, 6);

      window.Mercadopago.getInstallments({ bin, amount }, (status, res) => {
        if (status === 200) {
          resolve(res[0]);
        } else {
          reject(res.message);
        }
      });
    });
  },

  generateToken(form) {
    return new Promise((resolve, reject) => {
      Mercadopago.clearSession();
      Mercadopago.createToken(form, (status, response) => {
        if (response.error) {
          const err = new Error(response.error);
          err.errors = response.cause;
          return reject(err);
        } else {
          return resolve(response.id);
        }
      });
    });
  },

  mapErrorsToFields(errors) {
    return errors.map(e => this.getError(e.code));
  },

  getError(errorCode) {
    switch (errorCode) {
      case 'cc_rejected_bad_filled_card_number':
        return {
          field: 'number',
          message: 'Número de cartão inválido'
        };
      case 'E301':
        return {
          field: 'number',
          message: 'Número de cartão inválido'
        };
      case '205':
        break; // parameter cardNumber can not be null/empty
      case 'cc_rejected_bad_filled_date':
        return {
          field: 'expiration',
          message: 'Data de vencimento inválida'
        };
      case '208':
        return {
          field: 'expiration',
          message: 'Data de vencimento inválida'
        };
      case '325':
        return {
          field: 'expiration',
          message: 'Data de vencimento inválida'
        };
      case '209':
        return {
          field: 'expiration',
          message: 'Data de vencimento inválida'
        };
      case '326':
        return {
          field: 'expiration',
          message: 'Data de vencimento inválida'
        };
      case '212':
        break; // parameter docType can not be null/empty.
      case '213':
        break; // The parameter cardholder.document.subtype can not be null or empty.
      case '214':
        break; // parameter docNumber can not be null/empty.
      case '322':
        break; // invalid parameter docType.
      case '323':
        break; // Invalid parameter cardholder.document.subtype.
      case '324':
        return {
          field: 'cpf',
          message: 'CPF inválido'
        };
      case '220':
        return {
          field: 'issuer',
          message: 'Banco emissor inválido'
        };
      case '221':
        return {
          field: 'name',
          message: 'Nome do titular do cartão inválido'
        };
      case '316':
        return {
          field: 'name',
          message: 'Nome do titular do cartão inválido'
        };
      case 'cc_rejected_bad_filled_security_code':
        return {
          field: 'cvv',
          message: 'Código de segurança inválido'
        };
      case '224':
        break; // parameter securityCode can not be null/empty.
      case 'E302':
        return {
          field: 'cvv',
          message: 'Código de segurança inválido'
        };
      default:
        return null;
    }
  },

  getBank(ccNumber) {
    // Just nubank for now
    const bin = ccNumber.replace(/[ .-]/g, '').slice(0, 6);
    const nubankBins = [
      '550209',
      '516220',
      '523421',
      '554865',
      '230540',
      '230721',
      '516292',
      '516230',
      '522688',
      '525361',
      '520048'
    ];

    return nubankBins.includes(bin.toString()) ? 'nubank' : 'other';
  }
};
